import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import MapSection from './components/MapSection';
import ShopList from './components/ShopList';

export default function NearbyShops() {
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);
  const [selectedShop, setSelectedShop] = useState<number | null>(null);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsNavbarFixed(true);
    } else {
      setIsNavbarFixed(false);
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', handleScroll);
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50/30 via-white to-purple-50/20">
      <Navbar isFixed={isNavbarFixed} />
      
      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-light text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              주변 뷰티샵 찾기
            </h1>
            <p className="text-base text-gray-600">내 주변의 프리미엄 뷰티샵을 지도에서 확인하세요</p>
          </div>

          <MapSection selectedShop={selectedShop} onShopSelect={setSelectedShop} />
          
          <ShopList selectedShop={selectedShop} onShopSelect={setSelectedShop} />
        </div>
      </div>

      <Footer />
    </div>
  );
}
